<mat-tab-group (selectedTabChange)="onTabClick($event)" class="demo-tab-group">
    <mat-tab *ngFor="let tab of tabs; let i=index" label="{{ 'Tab'+i }}">
        <ng-template mat-tab-label>
            <button>
                {{ tab.title }}
            </button>
        </ng-template>
        <div class="demo-tab-content">
            <div class="lista-dados" *ngIf="children.length > 0">
                <ul>
                    <li>
                        <div class="colunas-extrato cePrimeiro">
                            <div class="correcao-local"></div>
                            <h6>Local</h6>
                        </div>
                        <div class="colunas-extrato ceSegundo">
                            <h6>Total</h6>

                        </div>
                        <div class="colunas-extrato ceTerceiro">
                            <h6>Dia</h6>

                        </div>
                        <div class="colunas-extrato ceQuarto">
                            <h6>Detalhe</h6>

                        </div>
                    </li>
                </ul>

                <ul *ngFor="let child of children">
                    <img [hidden]="true" src="assets/images/arrow-down.png">
                    <img [hidden]="true" src="assets/images/arrow-up.png">
                    <li>
                        <div class="colunas-extrato cePrimeiro">
                            <img *ngIf="child.transactionType === 1" src="assets/images/arrow-down.png">
                            <img *ngIf="child.transactionType !== 1" src="assets/images/arrow-up.png">
                            <h5>{{ child.name }}</h5>
                        </div>
                        <div class="colunas-extrato ceSegundo">
                            <h5>R$ {{ child.total.toFixed(2) }}</h5>
                        </div>
                        <div class="colunas-extrato ceTerceiro">
                            <div class="dado-complementar">{{ formatLocalDate(child.date) }}</div>
                        </div>
                        <div class="colunas-extrato ceQuarto">
                            <a class="btn-positive" *ngIf="child.transactionType === 1 && !child.open" (click)="openChildDetail(child.id)">
                                <i class="material-icons">control_point</i>
                            </a>

                            <a class="btn-negative" *ngIf="child.transactionType === 1 && child.open" (click)="closeChildDetal(child.id)">
                                <i class="material-icons">remove_circle_outline</i>
                            </a>
                        </div>
                    </li>
                    <div *ngIf="child.open && child.detail && child.detail.length > 0" class="list-consumo">
                        <ul>
                            <li>
                                <h1 class="lcPrimeiro">Produto</h1>
                                <h1 class="lcSegundo">Preço</h1>
                                <h1 class="lcTerceiro">Quantidade</h1>
                                <h1 class="lcQuarto">Total</h1>
                            </li>
                            <li *ngFor="let detail of child.detail">
                                <p class="lcPrimeiro">{{ detail.name }}</p>
                                <p class="lcSegundo">R$ {{ detail.price.toFixed(2) }}</p>
                                <p class="lcTerceiro">{{ detail.quantity }}x</p>
                                <p class="lcQuarto">R$ {{ detail.total.toFixed(2) }}</p>
                            </li>
                        </ul>
                    </div>
                </ul>

                <div *ngIf="children.length == 0">
                    <h5>Não há dados para exibir</h5>
                </div>
            </div>
        </div>
    </mat-tab>
</mat-tab-group>


// WEBPACK FOOTER //
// /usr/src/app/src/app/components/infinite-scroll-list/infinite-scroll-list.component.html